import cane01 from '@/assets/lootbox/candies/cane01.svg';
import cane02 from '@/assets/lootbox/candies/cane02.svg';
import cane03 from '@/assets/lootbox/candies/cane03.svg';
import cane04 from '@/assets/lootbox/candies/cane04.svg';
import lollypop01 from '@/assets/lootbox/candies/lollypop01.svg';
import lollypop02 from '@/assets/lootbox/candies/lollypop02.svg';
import lollypop03 from '@/assets/lootbox/candies/lollypop03.svg';
import lollypop04 from '@/assets/lootbox/candies/lollypop04.svg';
import round01 from '@/assets/lootbox/candies/round01.svg';
import round02 from '@/assets/lootbox/candies/round02.svg';
import round03 from '@/assets/lootbox/candies/round03.svg';
import round04 from '@/assets/lootbox/candies/round04.svg';
import round05 from '@/assets/lootbox/candies/round05.svg';
import star01 from '@/assets/lootbox/candies/star01.svg';
import star02 from '@/assets/lootbox/candies/star02.svg';
import star03 from '@/assets/lootbox/candies/star03.svg';
import star04 from '@/assets/lootbox/candies/star04.svg';
import star05 from '@/assets/lootbox/candies/star05.svg';
import wrapped01 from '@/assets/lootbox/candies/wrapped01.svg';
import wrapped02 from '@/assets/lootbox/candies/wrapped02.svg';
import wrapped03 from '@/assets/lootbox/candies/wrapped03.svg';
import wrapped04 from '@/assets/lootbox/candies/wrapped04.svg';
import wrapped05 from '@/assets/lootbox/candies/wrapped05.svg';
import wrapped06 from '@/assets/lootbox/candies/wrapped06.svg';

import bag0 from '@/assets/lootbox/thumbnails/bag0.png?format=webp&quality=60&as=src&imagetools';
import bag1 from '@/assets/lootbox/thumbnails/bag1.png?format=webp&quality=60&as=src&imagetools';
import bag2 from '@/assets/lootbox/thumbnails/bag2.png?format=webp&quality=60&as=src&imagetools';
import bag3 from '@/assets/lootbox/thumbnails/bag3.png?format=webp&quality=60&as=src&imagetools';
import bag4 from '@/assets/lootbox/thumbnails/bag4.png?format=webp&quality=60&as=src&imagetools';
import bagHalloween from '@/assets/lootbox/thumbnails/bagHalloween.png?format=webp&quality=60&as=src&imagetools';
import bagChristmas from '@/assets/lootbox/thumbnails/bagChristmas.png?format=webp&quality=60&as=src&imagetools';

export type Candy = {
	candy_image: string;
	proba: number;
	prize: number;
};

export type LootboxType = {
	candies: Candy[];
	visu_probas: number[];
	thumbnail: string;
	name: string;
	price: number;
};

const LootBox = (candies: Candy[], thumbnail: string, name: string, price: number): LootboxType => {
	const setVisuProbas = () => {
		const transformedProbas = candies.map((candy) => Math.pow(-1 / Math.log(candy.proba), 0.5));
		const sumTransformedProbas = transformedProbas.reduce((sum, p) => sum + p, 0);
		return candies.map((candy, index) => transformedProbas[index] / sumTransformedProbas);
	};

	return {
		candies,
		visu_probas: setVisuProbas(),
		thumbnail,
		name,
		price,
	};
};

export const candies_1_SUI: Candy[] = [
	{ candy_image: cane02, proba: 0.0001, prize: 100 },
	{ candy_image: lollypop02, proba: 0.0001, prize: 20 },
	{ candy_image: lollypop01, proba: 0.0001, prize: 10 },
	{ candy_image: wrapped02, proba: 0.03, prize: 5 },
	{ candy_image: wrapped01, proba: 0.04, prize: 3 },
	{ candy_image: star03, proba: 0.1, prize: 2 },
	{ candy_image: star02, proba: 0.1, prize: 1.5 },
	{ candy_image: star01, proba: 0.07, prize: 1.2 },
	{ candy_image: round04, proba: 0.12, prize: 0.8 },
	{ candy_image: round03, proba: 0.19, prize: 0.5 },
	{ candy_image: round02, proba: 0.19, prize: 0.2 },
	{ candy_image: round01, proba: 0.1597, prize: 0.1 },
];

export const candies_christmas: Candy[] = [
	{ candy_image: cane02, proba: 0.0001, prize: 50 },
	{ candy_image: cane01, proba: 0.0006, prize: 20 },
	{ candy_image: lollypop03, proba: 0.002, prize: 10 },
	{ candy_image: lollypop02, proba: 0.01, prize: 5 },
	{ candy_image: wrapped04, proba: 0.02, prize: 2 },
	{ candy_image: wrapped03, proba: 0.06, prize: 1 },
	{ candy_image: star04, proba: 0.06, prize: 0.9 },
	{ candy_image: star05, proba: 0.11, prize: 0.7 },
	{ candy_image: star02, proba: 0.13, prize: 0.4 },
	{ candy_image: round04, proba: 0.14, prize: 0.3 },
	{ candy_image: round03, proba: 0.15, prize: 0.2 },
	{ candy_image: round02, proba: 0.16, prize: 0.15 },
	{ candy_image: round01, proba: 0.1573, prize: 0.1 },
];

export const candies_5_SUI: Candy[] = [
	{ candy_image: cane02, proba: 0.0001, prize: 200 },
	{ candy_image: cane01, proba: 0.0001, prize: 100 },
	{ candy_image: lollypop02, proba: 0.01, prize: 50 },
	{ candy_image: lollypop01, proba: 0.01, prize: 20 },
	{ candy_image: wrapped02, proba: 0.03, prize: 15 },
	{ candy_image: wrapped01, proba: 0.04, prize: 10 },
	{ candy_image: star03, proba: 0.1, prize: 8 },
	{ candy_image: star02, proba: 0.11, prize: 6 },
	{ candy_image: star01, proba: 0.09, prize: 4 },
	{ candy_image: round04, proba: 0.15, prize: 3 },
	{ candy_image: round03, proba: 0.18, prize: 2.5 },
	{ candy_image: round02, proba: 0.1549, prize: 2 },
	{ candy_image: round01, proba: 0.1249, prize: 1 },
];

export const candies_halloween: Candy[] = [
	{ candy_image: cane02, proba: 0.0001, prize: 500 },
	{ candy_image: cane01, proba: 0.04, prize: 25 },
	{ candy_image: lollypop03, proba: 0.04, prize: 20 },
	{ candy_image: lollypop02, proba: 0.1, prize: 15 },
	{ candy_image: wrapped04, proba: 0.1, prize: 12 },
	{ candy_image: wrapped03, proba: 0.1, prize: 10 },
	{ candy_image: star04, proba: 0.06, prize: 7 },
	{ candy_image: star05, proba: 0.06, prize: 5 },
	{ candy_image: star02, proba: 0.07, prize: 4 },
	{ candy_image: round04, proba: 0.09, prize: 3 },
	{ candy_image: round03, proba: 0.12, prize: 2.5 },
	{ candy_image: round02, proba: 0.12, prize: 2 },
	{ candy_image: round01, proba: 0.0999, prize: 1 },
];

export const candies_10_SUI: Candy[] = [
	{ candy_image: cane03, proba: 0.0001, prize: 1000 },
	{ candy_image: cane02, proba: 0.0001, prize: 500 },
	{ candy_image: cane01, proba: 0.01, prize: 100 },
	{ candy_image: lollypop03, proba: 0.01, prize: 40 },
	{ candy_image: lollypop02, proba: 0.03, prize: 30 },
	{ candy_image: lollypop01, proba: 0.04, prize: 20 },
	{ candy_image: wrapped03, proba: 0.1, prize: 15 },
	{ candy_image: wrapped02, proba: 0.11, prize: 12 },
	{ candy_image: star03, proba: 0.09, prize: 8 },
	{ candy_image: star02, proba: 0.15, prize: 6 },
	{ candy_image: round04, proba: 0.18, prize: 5 },
	{ candy_image: round03, proba: 0.1549, prize: 4 },
	{ candy_image: round02, proba: 0.1249, prize: 1 },
];

export const candies_20_SUI: Candy[] = [
	{ candy_image: cane04, proba: 0.0001, prize: 2000 },
	{ candy_image: cane03, proba: 0.0001, prize: 1000 },
	{ candy_image: cane02, proba: 0.0001, prize: 500 },
	{ candy_image: cane01, proba: 0.005, prize: 100 },
	{ candy_image: lollypop04, proba: 0.01, prize: 50 },
	{ candy_image: lollypop03, proba: 0.04, prize: 40 },
	{ candy_image: lollypop02, proba: 0.08, prize: 35 },
	{ candy_image: wrapped04, proba: 0.09, prize: 30 },
	{ candy_image: wrapped03, proba: 0.13, prize: 25 },
	{ candy_image: star04, proba: 0.15, prize: 17 },
	{ candy_image: star03, proba: 0.15, prize: 15 },
	{ candy_image: round04, proba: 0.185, prize: 10 },
	{ candy_image: round03, proba: 0.1597, prize: 2 },
];

export const candies_50_SUI: Candy[] = [
	{ candy_image: cane04, proba: 0.0001, prize: 5000 },
	{ candy_image: cane03, proba: 0.0001, prize: 2500 },
	{ candy_image: cane02, proba: 0.0001, prize: 1000 },
	{ candy_image: cane01, proba: 0.005, prize: 500 },
	{ candy_image: lollypop04, proba: 0.01, prize: 250 },
	{ candy_image: lollypop03, proba: 0.05, prize: 100 },
	{ candy_image: lollypop02, proba: 0.1, prize: 70 },
	{ candy_image: lollypop01, proba: 0.1, prize: 65 },
	{ candy_image: wrapped06, proba: 0.15, prize: 60 },
	{ candy_image: wrapped05, proba: 0.05, prize: 50 },
	{ candy_image: wrapped04, proba: 0.13, prize: 40 },
	{ candy_image: wrapped03, proba: 0.12, prize: 25 },
	{ candy_image: star05, proba: 0.185, prize: 10 },
	{ candy_image: round05, proba: 0.0997, prize: 5 },
];

export const lootbox_1_SUI = LootBox(candies_1_SUI, bag0, 'Lucky One', 1);
export const lootbox_christmas = LootBox(candies_christmas, bagChristmas, 'SuiXmas', 0.5);
export const lootbox_5_SUI = LootBox(candies_5_SUI, bag1, 'Rookie', 5);
export const lootbox_halloween = LootBox(candies_halloween, bagHalloween, 'Halloween', 8);
export const lootbox_10_SUI = LootBox(candies_10_SUI, bag2, 'Original', 10);
export const lootbox_20_SUI = LootBox(candies_20_SUI, bag3, 'Suigar', 20);
export const lootbox_50_SUI = LootBox(candies_50_SUI, bag4, 'Suipreme', 50);
export const lootboxes = [
	lootbox_christmas,
	lootbox_1_SUI,
	lootbox_5_SUI,
	// lootbox_halloween,
	lootbox_10_SUI,
	lootbox_20_SUI,
	lootbox_50_SUI,
];
